import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';
import { compose } from 'redux';
import withStyles, { WithStyles } from 'react-jss';
import Icon from "../Icon";

export interface ICalloutProps {
    /** Callout intent */
    intent?: 'default' | 'danger' | 'success' | 'warning';
    /** className to append */
    className?: string;
    /** Accessibility */
    isAlert?: boolean;
    ariaLive?: 'off' | 'polite' | 'assertive';
}

interface IState {
}

type Props = ICalloutProps & WithStyles<typeof styles>;

/**
 * Callouts visually highlight important content for the user.
 */
class Callout extends React.Component<Props, IState> {
    static displayName: string = 'Callout';

    render () {
        return (
            <div
                className={classNames('callout', {
                    'callout-default': this.props.intent === 'default' || !this.props.intent,
                    'callout-danger': this.props.intent === 'danger',
                    'callout-warning': this.props.intent === 'warning',
                    'callout-success': this.props.intent === 'success',
                }, this.props.className, this.props.classes.callout)}
                aria-live={this.props.ariaLive}
                role={this.props.isAlert ? 'alert' : undefined}
            >
                {this.props.intent === 'danger' && <Icon kind="status-error" width={20} height={20} className="callout-icon"/> }
                {this.props.intent === 'success' && <Icon kind="status-success" width={20} height={20} className="callout-icon"/> }
                {this.props.intent === 'warning' && <Icon kind="alert" width={20} height={20} className="callout-icon"/> }

                <div className="callout-content">
                    <span className="callout-text">{this.props.children}</span>
                </div>
            </div>
        );
    }
}

const styles = (theme) => {
    return {
        callout: {
            ...theme.colors.components.callout,
        },
    };
};

export default compose<React.ComponentClass<ICalloutProps>>(
    withStyles(styles, { injectTheme: true })
)(Callout);
